<div class="template-config-container">

    <form [formGroup]="plantillaForm">

        <!-- ============================================ -->
        <!-- INFORMACIÓN GENERAL -->
        <!-- ============================================ -->

        <div class="form-section">

            <div class="section-header">
                <div>
                    <h5 class="section-title">
                        Información de la plantilla
                    </h5>

                    <p class="section-description">
                        Define el nombre y la visibilidad de la plantilla.
                    </p>
                </div>
            </div>


            <!-- ======================================== -->
            <!-- NOMBRE -->
            <!-- ======================================== -->

            <div class="field-group">

                <label for="title" class="form-label">
                    Nombre de plantilla
                    <span class="required-mark">*</span>
                </label>

                <div class="input-wrapper"
                    [class.is-invalid]="
                        plantillaForm.get('nombre')?.touched &&
                        plantillaForm.get('nombre')?.invalid
                    ">

                    <div class="input-icon">
                        <i class="fa-solid fa-file-lines"></i>
                    </div>

                    <input
                        id="title"
                        type="text"
                        formControlName="nombre"
                        class="form-control"
                        placeholder="Ej. Plantilla laboral"
                    />

                </div>


                <!-- ERROR -->

                <div
                    class="field-error"
                    *ngIf="
                        plantillaForm.get('nombre')?.touched &&
                        plantillaForm.get('nombre')?.errors?.['required']
                    ">

                    <i class="fa-solid fa-circle-exclamation"></i>

                    <span>
                        El nombre de la plantilla es requerido.
                    </span>

                </div>

            </div>


            <!-- ======================================== -->
            <!-- PLANTILLA PÚBLICA -->
            <!-- ======================================== -->

            <div
                class="visibility-option"
                *ngIf="accesUser"
                [class.is-enabled]="plantillaForm.get('publica')?.value">

                <div class="visibility-content">

                    <div class="visibility-icon">

                        <i
                            class="fa-solid"
                            [ngClass]="
                                plantillaForm.get('publica')?.value
                                    ? 'fa-globe'
                                    : 'fa-lock'
                            ">
                        </i>

                    </div>


                    <div class="visibility-info">

                        <div class="visibility-title-row">

                            <span class="visibility-title">
                                Hacer pública la plantilla
                            </span>

                            <span
                                class="visibility-status"
                                [class.public]="plantillaForm.get('publica')?.value">

                                {{
                                    plantillaForm.get('publica')?.value
                                        ? 'Pública'
                                        : 'Privada'
                                }}

                            </span>

                        </div>


                        <span class="visibility-description">

                            {{
                                plantillaForm.get('publica')?.value
                                    ? 'Esta plantilla podrá ser utilizada por otros usuarios.'
                                    : 'Esta plantilla estará disponible únicamente para ti.'
                            }}

                        </span>

                    </div>

                </div>


                <!-- SWITCH -->

                <label class="modern-switch">

                    <input
                        type="checkbox"
                        id="publica"
                        formControlName="publica"
                    />

                    <span class="slider"></span>

                </label>

            </div>

        </div>

    </form>

</div>